__turbopack_context__.v({
  "shimmer": "skeleton-module__EfwldW__shimmer",
  "skeleton": "skeleton-module__EfwldW__skeleton",
  "skeleton--animated": "skeleton-module__EfwldW__skeleton--animated",
  "skeleton--circle": "skeleton-module__EfwldW__skeleton--circle",
  "skeleton-text-group": "skeleton-module__EfwldW__skeleton-text-group",
});
